import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from "../layout/element/button.component";
import { addSystemAsAUser, createPlaceHolderImage, CreatePlaceHolderImageVariables, getItems, GetItemsVariables, insertMainSegments, insertMainStatuses, readMainStatus } from '@dataconnect/account';
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { Functions } from '@angular/fire/functions';
import { Store } from '@ngrx/store';
import { authUserFeature } from '../../store/authUser.store';
import { lastValueFrom, take } from 'rxjs';
import { uiErrorCatcher } from '../../helper/error.handling';
import { MatSnackBar } from '@angular/material/snack-bar';
import { onCallFunctions } from '../../../../globalTypes/backend.api.types';
import { deleteAllAccounts } from '../../../../functions/src';

@Component({
  selector: 'msh-controls',
  imports: [ButtonComponent],
  template: `

    <div class="m-16 grid grid-cols-3 gap-3">
      @for(btn of btns; let i = $index; track i){
        <msh-button [isLoading]="btnObj['btn_'+(i+1)].loading" [cta]="btn.cta" (onClick)="btn.func(i+1)"></msh-button>
      }
    </div>
  `,
  styles: ``
})
export class ControlsDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ControlsDialogComponent>);

  btns = [
    {cta: 'Get Started', func: this.runDatFunction.bind(this)},
    {cta: 'Create Placeholder', func: this.createImagePlaceholderFunc.bind(this)},
    {cta: 'Re-run Webhook', func: this.tryWebhooksAgain.bind(this)},
    {cta: 'Get order items', func: this.checkOrderItems.bind(this)},
    {cta: 'Delete all accounts', func: this.deleteAllAccountsFunc.bind(this)},
    {cta: 'Fake an error', func: this.fakeAnError.bind(this)},
    {cta: 'Set up taxes', func: this.setUpTaxes.bind(this)},
    {cta: 'Query all orders', func: this.getAllOrders.bind(this)},
    {cta: 'Send Email', func: this.sendEmail.bind(this)},
    {cta: 'Add System User', func: this.addSystemAsAUser.bind(this)},
  ]
  btnObj:{[instance:string]:{loading: boolean}}={}
  constructor(
    private functions: Functions,
    private snackBar: MatSnackBar,
    private store: Store,
  ){
    for (let index = 1; index <= this.btns.length; index++) {
      this.btnObj['btn_'+index] = {...this.btns[index-1], loading: false}
    }
    console.log({btnObj: this.btnObj});
    
  }

  btnIndication(num: number, loading: boolean) {
    this.btnObj["btn_"+num].loading = loading;
  }

  async runDatFunction(num: number){
    this.btnIndication(num, true)
    // InsertMainStatuses
    const dat = await insertMainStatuses();
    const daFunc = await insertMainSegments();
    const readData = await readMainStatus();
    console.log({dat, daFunc, readData})
    this.btnIndication(num, false)
  }

  async tryWebhooksAgain(num: number){
    this.btnIndication(num, true)
    // console.log("function was removed")
    const callable = httpsCallable(this.functions,   onCallFunctions.tempProcessWebhooks)
    const result: HttpsCallableResult = await callable({});
    console.log({result})
    this.btnIndication(num, false)
  }

  async checkOrderItems(num: number){
    this.btnIndication(num, true)
    const vars: GetItemsVariables = {
      id: "1e4b48bdc5b3476891c095ac0fa884f4",
      fulfilledByLocationId: "a882403abb6341b9bd0d692674ed78e5",
    }
    const readData = await getItems(vars);
    console.log({vars, readData})
    this.btnIndication(num, false)
  }

  // async addSampleQuestion(num: number){
  //   this.btnIndication(num, true)
  //   const questions = await addSampleListingQuestions();
  //   console.log({questions})
  //   this.btnIndication(num, false)
  // }

  async createImagePlaceholderFunc(num: number){
    this.btnIndication(num, true)
    const vars: CreatePlaceHolderImageVariables = {
      url: "ListingPlaceHolder.png",
    }
    const imageData = await createPlaceHolderImage(vars);
    console.log({vars, imageData})
    this.btnIndication(num, false)
  }

  async deleteAllAccountsFunc(num: number){
    this.btnIndication(num, true)
    const callable = httpsCallable(this.functions, onCallFunctions.deleteAllAccounts)
    const results: HttpsCallableResult = await callable({});
    console.log({results});
    this.btnIndication(num, false)
  }

  async fakeAnError(num: number){
    this.btnIndication(num, true)
    setTimeout(()=>{
      this.btnIndication(num, false)
      uiErrorCatcher(
        new Promise((resolve, reject) => {
          console.log('will resolve')
          reject('done')
        }), this.snackBar, 'Don\'t judge me, I am a fake and I know it!')
    }, 1000)
  }

  async setUpTaxes(num: number){
    this.btnIndication(num, true);
    try {
      const callable = httpsCallable(this.functions, onCallFunctions.setUpTaxes)
      const results: HttpsCallableResult = await callable({});
      console.log({results});
    } catch(e:any){
      console.error({e})
    }
    this.btnIndication(num, false)
  }

  async getAllOrders(num: number){
    this.btnIndication(num, true);
    try {
      const callable = httpsCallable(this.functions, onCallFunctions.tmpQueryAllOrders);
      const results: HttpsCallableResult = await callable({});
      console.log({results})
    } catch (e: any) {
      console.error(e)
    }
    this.btnIndication(num, false);
  }
  async sendEmail(num: number){
    this.btnIndication(num, true);
    try {
      const callable = httpsCallable(this.functions, onCallFunctions.sendTestEmail);
      const results: HttpsCallableResult = await callable({});
      console.log({results})
    } catch (e: any) {
      console.error(e)
    }
    this.btnIndication(num, false);
  }
  async addSystemAsAUser(num: number){
    this.btnIndication(num, true);
    try {
      const results = await uiErrorCatcher(addSystemAsAUser(), this.snackBar, "Error adding system as a user")
      console.log({results})
      this.snackBar.open("System user added ", "Close", {duration: 10000})
    } catch (e: any) {
      console.error(e)
    }
    this.btnIndication(num, false);
  }
}


